import { useEffect } from "react"

export default function ReportDrillDown() {

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const cmsURL = params.get("url");

        if (cmsURL) {
          window.open(
            cmsURL,
            "newWindow",
            "width=900,height=550,alwaysRaised=yes,toolbar=yes,menubar=yes,location=yes,resizable=yes"
          );
          window.history.back();
        }

    });

    return <></>
}